<script setup lang="ts">
import GenericFilterSelect from '../GenericFilterSelect.vue';
import { getImageUrl } from './utility';
import { useFrontlineFiltersStore } from '@Portal/stores/frontlineFilters';

defineProps<{
  title: string;
  firstName: string;
  pendingCount: number;
}>();
const backgroundUrl = getImageUrl('/frontline/FrontlineDashboard_TopBanner_Background.svg');

const filterOpen = ref(false);
const appliedFilters = ref(false);
const frontlineStore = useFrontlineFiltersStore();
</script>

<template>
  <div
    class="h-100% flex flex-col justify-around bg-no-repeat bg-cover border-rounded-1"
    :style="{ 'background-image': `url(${backgroundUrl})` }"
  >
    <div class="pl-3 lg:pl-7 pr-3 lg:pr-7 pt-4 pb-4 text-white">
      <p class="font-600 text-4 m-0 font-family[Poppins]">Delight your customers today, {{ firstName }}!</p>
      <div v-if="frontlineStore.possibleFilters" class="flex items-center pt-2 pr-2">
        <div
          class="font-400 text-3 uppercase float-left text-left font-family[Roboto] sm:max-w-[40rem] xs:max-w-[16rem]"
          :class="{
            'line-clamp-[1]': !appliedFilters,
          }"
        >
          {{
            (frontlineStore.claimsSelected.length > 0
              ? frontlineStore.claimsSelected
              : frontlineStore.possibleFilters.Claims.filterDimensionValues.map((x) => x.dimensionValue)
            )?.join(', ')
          }}
          <span
            v-if="appliedFilters"
            class="uppercase underline font-family[Roboto] text-3 pl-2 text-white cursor-pointer"
            @click="
              frontlineStore.claimsSelected = frontlineStore.possibleFilters.Claims.filterDimensionValues.map(
                (x) => x.dimensionValue
              );
              appliedFilters = false;
            "
          >
            Clear
          </span>
        </div>
        <div class="select-none relative">
          <div
            v-if="!appliedFilters && frontlineStore.possibleFilters.Claims.filterDimensionValues.length > 1"
            @click="filterOpen = !filterOpen"
            :class="{
              'rotate-270': !filterOpen,
              'rotate-90': filterOpen,
            }"
            class="transition i-mdi-chevron-left cursor-pointer pl-2 text-white outline-none"
          />
          <GenericFilterSelect
            v-if="filterOpen"
            class="absolute z-50 mt-1 right-0"
            :choices="frontlineStore.possibleFilters.Claims.filterDimensionValues.map((value) => value.dimensionValue)"
            :selected-values="frontlineStore.claimsSelected"
            @apply="
              (newItems) => {
                filterOpen = false;
                frontlineStore.claimsSelected = newItems;
                appliedFilters = true;
              }
            "
          ></GenericFilterSelect>
        </div>
      </div>
    </div>
  </div>
</template>
